import { QueryCache } from '@tanstack/react-query';
import { toast } from 'sonner';
import { ErrorCode } from '@/lib/errors/codes';
import { getErrorCode, getErrorMessage } from '@/lib/errors/get-error';
import { redirectToPaywallIfInactive } from './paywall';

interface QueryMeta extends Record<string, unknown> {
  /** Fallback du toast d'erreur pour cette query. */
  errorMessage?: string;
  /** Supprime entièrement le toast d'erreur. */
  noErrorToast?: boolean;
}

declare module '@tanstack/react-query' {
  interface Register {
    queryMeta: QueryMeta;
  }
}

export const queryCache = new QueryCache({
  onError: (error, query) => {
    // Session expirée/absente : condition normale, gérée par le refresh
    // on-401 puis la redirection /login — pas un incident à toaster.
    if (getErrorCode(error) === ErrorCode.UNAUTHORIZED) return;
    // Abonnement inactif → paywall (sauf si on y est déjà) : gate les écrans
    // dont les queries sont protégées par la garde d'abonnement.
    if (redirectToPaywallIfInactive(error)) return;
    if (query.meta?.noErrorToast) return;
    toast.error(getErrorMessage(error, query.meta?.errorMessage));
  },
});
